import { customization } from '@yola/ws-sdk';
import { HSLColor, contrastRatio } from '@yola/yola-palette-generator';
import getBlockSurface from '../../website-design/helpers/get-block-surface';
import getBlockSurfaceName from '../../website-design/helpers/get-block-surface-name';
import getBlockSurfaceBackground from '../../website-design/helpers/get-block-surface-background';
import parseHslColorString from '../../website-design/helpers/parse-hsl-color-string';

const LIGHT_CR = 3;
const WHITE_HSL = new HSLColor(0, 0, 1);
const COLUMN_WITH_SURFACE_SELECTOR = 'ws-column[surface]';

const getHighlighterColor = (element, options) => {
  if (!options.hovered) {
    return 'default';
  }

  const columnWithSurface = element.closest(COLUMN_WITH_SURFACE_SELECTOR);

  const surface = columnWithSurface
    ? columnWithSurface.getAttribute('surface')
    : getBlockSurface(element);

  if (!surface) {
    return 'default';
  }

  const currentPalette = customization.accessors.getCurrentColorPalette();
  const surfaceName = getBlockSurfaceName(surface);
  const background = getBlockSurfaceBackground(surfaceName, currentPalette.variables);
  const backgroundHSL = new HSLColor(...Object.values(parseHslColorString(background)));

  const isLightSurface = contrastRatio(backgroundHSL, WHITE_HSL) < LIGHT_CR;

  return isLightSurface ? 'dark' : 'light';
};

export default getHighlighterColor;
